
<div class="h-100 white">
    <c-dms-documents
        :step-data-id = "collectionId"
        :bid-id       = "bidId"
        :step-name    = "bidName"
        :documents    = documents
        :compact      = "true"
        category     = "repairService"
    />
</div>
